import React from 'react'
import styled, { css } from 'styled-components'
import { Box, Grid } from 'ui/acro'
import SearchBox from './SearchBox'
import { ChevronRightIcon } from 'components_v2/Icons'
import { Link } from 'react-router-dom'

const FlexContainer = styled(Grid)((props) =>
  css({
    width: '100%',
    textTransform: 'uppercase',
    fontFamily: 'Arquitecta',
    fontSize: '15px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.08em',
    textAlign: 'left',
    '.breadcrumbs-flex': {
      gap: '0 10px'
    },
    '@media only screen and (max-width: 1024px)': {
      gap: '10px'
    },
    '.unselected': {
      color: '#636363'
    },
    '.unselected:hover, .selected': {
      color: '#000',
      display: 'inline-block'
    }
  })
)

const BreadcrumbBar = ({ categoryName, slug, categoryDisplayName }) => {
  return (
    <FlexContainer
      padding={['20px 0 10px 0', null, null, '50px 0 0 0']}
      gridTemplateColumns={['100%', null, null, '70% 30%']}
    >
      <Box
        className='breadcrumbs-flex'
        flexGrow={1}
        alignSelf={'center'}
        display='flex'
        flexWrap='wrap'
      >
        <Box as={Link} to={`/support/`} className='unselected unstyled'>
          FAQ
        </Box>
        <>
          <ChevronRightIcon color='black' />
          <Box
            as={Link}
            className={`${slug ? 'unselected' : 'selected'} unstyled`}
            to={`/support/${categoryName}`}
          >
            {categoryDisplayName}
          </Box>
        </>
        {slug && (
          <>
            <ChevronRightIcon color='black' />
            <Box className='selected unstyled'>Articles</Box>
          </>
        )}
      </Box>
      <Box>
        <SearchBox />
      </Box>
    </FlexContainer>
  )
}

export default BreadcrumbBar
